export default "__VITE_ASSET__CmE6Wkb6__"